// Normalises the two success envelopes the portal receives (PB-1539):
//  - BFF / auth-service:        { status: 200, data }
//  - backend-api (RuoYi style): { code: 0, msg, data }   (no `status` field)
// Gating only on `status === 200` silently dropped backend-api payloads
// (e.g. the PS Payout Schedule), so callers should use these helpers.

export const isOkResponse = (resp) =>
  resp != null && (resp.status === 200 || resp.code === 0);

export const responseData = (resp, fallback = null) =>
  isOkResponse(resp) ? (resp.data ?? fallback) : fallback;
